import {styled} from '@linaria/react';
// eslint-disable-next-line import/no-namespace
import * as riveApp from '@rive-app/react-canvas';
import React, {FC, useEffect} from 'react';

/**
 * importing the whole library and destructuring is necessary to avoid the following error when using Rive in a Vite environment:
 * [vite] Named export 'Layout' not found. The requested module '@rive-app/react-canvas' is a CommonJS module...
 * */
const {Alignment, Fit, Layout, useRive, useViewModelInstanceBoolean} = riveApp;

export const CoinsExplosionAnimation: FC<{
  showBodyContent: boolean;
  riveSrc: string;
}> = ({showBodyContent, riveSrc}) => {
  const {RiveComponent: ClaimedCoinsExplosion, rive} = useRive(
    {
      src: riveSrc,
      stateMachines: 'State Machine 1',
      autoBind: true,
      autoplay: true,
      layout: new Layout({
        fit: Fit.Cover,
        alignment: Alignment.Center,
      }),
    },
    {
      // ensures the canvas matches the device's pixel density
      useDevicePixelRatio: true,
      shouldResizeCanvasToContainer: true,
    },
  );

  const viewModelInstance = rive?.viewModelInstance;

  const {setValue: setAnimationPlayValue} = useViewModelInstanceBoolean(
    'play',
    viewModelInstance,
  );

  useEffect(() => {
    if (showBodyContent && viewModelInstance) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setAnimationPlayValue(true);
    }
  }, [showBodyContent, viewModelInstance]);

  return (
    <ClaimedCoinsExplosionWrapper>
      <ClaimedCoinsExplosion />
    </ClaimedCoinsExplosionWrapper>
  );
};

const ClaimedCoinsExplosionWrapper = styled.div`
  inset: 0;
  position: absolute;
  z-index: 0;
`;
